"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Request = require('superagent');

var _require = require('crypto-js'),
    md5 = _require.MD5;

var SoulModule = require('./SoulModule');

var uuid = require('uuid');

var queryString = require('query-string');
/**
* Interact with other users (like, ban, etc.)
* @extends SoulModule
*/


var Users =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Users, _SoulModule);

  function Users(params) {
    var _this;

    _classCallCheck(this, Users);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Users).call(this, params));
    _this.anonymousUserServiceKey = params.anonymousUserServiceKey;
    return _this;
  }
  /**
  * get recommended users
  * @param {Object} params
  * @param {string} [params.viewingSession]
  * Exactly the same viewingSession will be automatically used while the session.
  * Use this parameter only in case you need to refresh the recommendations or
  * to get users that were already viewed.
  * Useful when using the same application by one user from different clients
  * (e.g. iPhone and iPad) to have separate recommendations.
  * @param {string} [params.uniqueToken]
  * Pass any random string here on each subsequential request.
  * If any of requests fails due to any network-related issue, you can retry
  * the latest request by passing the same uniqueToken, so you won't miss any new users.
  * Note: do not rely on this parameter for paging through users.
  * @return {Promise}
  * @soulsdk soul.users.getRecommended
  * @example soul.users.getRecommended({
  *   viewingSession: '26d6a3a5-417c-40e9-b74f-3ddb6bf3ff70',
  *   uniqueToken: 'fb1280ef-a22f-4f82-b03b-a9568a253b90'
  * })
  */


  _createClass(Users, [{
    key: "getRecommended",
    value: function getRecommended() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var viewingSession = params.viewingSession,
          uniqueToken = params.uniqueToken;
      var storage = this.storage;
      viewingSession = (viewingSession || storage.get('viewingSession') || uuid()).toString();
      uniqueToken = (uniqueToken || uuid()).toString();
      this.storage.set('viewingSession', viewingSession);
      this.storage.set('uniqueToken', uniqueToken);
      return this.api.get('users/recommendations/list', {
        viewingSession: viewingSession,
        uniqueToken: uniqueToken
      });
    }
    /**
     * Returns cached viewingSession and uniqueToken
     * Might be used to pass these params to Users.getRecommended
     * @return {{viewingSession: string, uniqueToken: string}}
     */

  }, {
    key: "getRecommendedSessionParams",
    value: function getRecommendedSessionParams() {
      var storage = this.storage;
      var viewingSession = storage.get('viewingSession');
      var uniqueToken = storage.get('uniqueToken');
      return {
        viewingSession: viewingSession,
        uniqueToken: uniqueToken
      };
    }
    /**
    * Returns current filter set for recommendations
    * @return {Promise}
    * @soulsdk soul.users.getRecommendedFilter
    */

  }, {
    key: "getRecommendedFilter",
    value: function getRecommendedFilter(params) {
      return this.api.get('users/recommendations/filter', params);
    }
    /**
    * Changes the filter applied to users returned by users.getRecommended().
    * Takes a dictionary of filterable parameters that you want to apply.
    * @param {Object} [params]
    * @param {Object} [params.filter]
    * Dictionary with any filterable User fields you want to apply to filter.
    * @param {Object} [params.settings] Filter settings
    * @param {Number(float)} params.settings.locationMaxDistanceKm
    * Radius in kilometers in which the users will be recommended
    * @param {Boolean} params.settings.geo
    * set to true if you want the recommendations to be sorted and filtered by distance
    * @param {Boolean} params.settings.availability
    * set to true if you want to get only users who are available
    * (their availableTill parameter is set in the future)
    * @todo TODO add filter tutorial(gt, gte ...)
    * @return {Promise}
    * @soulsdk soul.users.updateRecommendedFilter
    * @example soul.users.updateRecommendedFilter({
    *  settings: {
    *   locationMaxDistanceKm: 10,
    *   availability: true
    *  }
    * })
    */

  }, {
    key: "updateRecommendedFilter",
    value: function updateRecommendedFilter(params) {
      return this.api.patch('users/recommendations/filter', params);
    }
    /**
    * Returns a pageable list of users filtered by a predefined filter {filterName}.
    * Filters can be defined in your Application Configuration.
    * @param {Object} params
    * @param {Object} [params.filterName]
    * @param {Object} [params.parameters.offset]
    * @param {Object} [params.parameters.limit]
    * @return {Promise}
    * @soulsdk soul.users.getFilteredBy
    * @example soul.users.getFilteredBy({
    *   filterName: 'yourfilterName',
    *   limit: 10
    * })
    */

  }, {
    key: "getFilteredBy",
    value: function getFilteredBy(_ref) {
      var filterName = _ref.filterName,
          parameters = _ref.parameters;
      var anonymousUser = this.storage.get('anonymous_user');
      return this.api.get("users/set/".concat(filterName), _objectSpread({}, parameters, anonymousUser && {
        anonymousUser: anonymousUser,
        apiKey: this.apiKey
      }));
    }
    /**
    * Returns filter settings
    * @return {Promise}
    * @soulsdk soul.users.getFilter
    * @example soul.users.getFilter({
    *   filterName: 'yourfilterName',
    * })
    *
    */

  }, {
    key: "getFilter",
    value: function getFilter(_ref2) {
      var filterName = _ref2.filterName;
      return this.api.get("users/set/".concat(filterName, "/filter"));
    }
    /**
    * Update filter settings
    * @param {Object} params
    * @param {String} params.filterName
    * @param {Object} params.filter.user
    * Dictionary with any User filterable fields you want to apply to filter.
    * Pass as many as you want.
    * @param {Object} params.filter.reactions
    * Set this if you want to filter users by receieved or sent reactions.
    * Can contain two dictionaries:
    * @param {Object} params.filter.reactions.receivedFromUser
    * filters users by received reactions.
    * Should contain "reactionType": "reacton" values, e.g. "liking":"liked"
    * will return users that sent you a like reaction of type liking
    * @param {Object} params.filter.reactions.sentByMe
    * dictionary that lets you filter users by reactions that current user sent to them
    * @todo TODO add filter tutorial(gt, gte ...)
    * @return {Promise}
    * @soulsdk soul.users.updateFilter
    */

  }, {
    key: "updateFilter",
    value: function updateFilter(_ref3) {
      var filterName = _ref3.filterName,
          filter = _ref3.filter;
      var anonymousUser = this.storage.get('anonymous_user');
      return this.api.patch("users/set/".concat(filterName, "/filter"), _objectSpread({}, filter, anonymousUser && {
        anonymousUser: anonymousUser,
        apiKey: this.apiKey
      }));
    }
    /**
    * Returns user by id
    * @param {Object} params
    * @param {String} params.userId
    * @return {Promise}
    * @soulsdk soul.users.get
    * @example soul.users.get({
    *   userId: 'fb1280ef-a22f-4f82-b03b-a9568a253b90'
    * })
    */

  }, {
    key: "get",
    value: function get(_ref4) {
      var userId = _ref4.userId;
      return this.api.get("users/".concat(userId));
    }
    /**
    * Sets reacton to user
    * @param {Object} params
    * @param {String} params.userId
    * @param {String} params.reactionType
    * @param {String} params.reaction.value
    * Value of the submitted reaction
    * @param {Number} params.reaction.expiresTime
    * Expiration time of sumbitted reaction. Defaults to the one set in Application Configuration
    * @return {Promise}
    * @soulsdk soul.users.react
    */

  }, {
    key: "react",
    value: function react(_ref5) {
      var userId = _ref5.userId,
          reactionType = _ref5.reactionType,
          reaction = _ref5.reaction;
      return this.api.post(function (res) {
        return _objectSpread({
          additionalInfo: res.additionalInfo,
          events: res.events
        }, res.user.reactions.sentByMe);
      }, "users/".concat(userId, "/reactions/sent/").concat(reactionType), reaction);
    }
    /**
    * delete reacton
    * @param {Object} params
    * @param {String} params.userId
    * @param {String} params.reactionType
    * @return {Promise}
    * @soulsdk soul.users.deleteReaction
    * @example soul.users.deleteReaction({
    *   userId: 'fb1280ef-a22f-4f82-b03b-a9568a253b90',
    *   reactionType: 'like',
    * })
    */

  }, {
    key: "deleteReaction",
    value: function deleteReaction(_ref6) {
      var userId = _ref6.userId,
          reactionType = _ref6.reactionType;
      return this.api["delete"]("users/".concat(userId, "/reactions/sent/").concat(reactionType));
    }
    /**
    * Reports the user to the moderator
    * @param {Object} params
    * @param {String} params.userId
    * @param {Object} params.report
    * @param {String} params.report.reason
    * One of the flag reasons as defined in Application Configuration
    * @param {String} [params.report.comment]
    * Comment for the moderator
    * Expiration time of sumbitted reaction. Defaults to the one set in Application Configuration
    * @return {Promise}
    * @soulsdk soul.users.report
    * @example soul.users.report({
    *   userId: 'fb1280ef-a22f-4f82-b03b-a9568a253b90',
    *   report: {
    *     reason: 'sex for money',
    *     comment: 'Text about this bad guy'
    *   }
    * })
    */

  }, {
    key: "report",
    value: function report(_ref7) {
      var userId = _ref7.userId,
          _report = _ref7.report;
      return this.api.post("users/".concat(userId, "/flag"), _report);
    }
    /**
    * Delete report about user
    * @param {Object} params
    * @param {String} params.userId
    * @return {Promise}
    * @soulsdk soul.users.deleteReport
    * @example soul.users.deleteReport({
    *   userId: 'fb1280ef-a22f-4f82-b03b-a9568a253b90',
    * })
    */

  }, {
    key: "deleteReport",
    value: function deleteReport(_ref8) {
      var userId = _ref8.userId;
      return this.api["delete"]("users/".concat(userId, "/flag"));
    }
  }, {
    key: "getFeed",
    value: function getFeed(params, location_with_radius_string) {
      // arrayFormat не работает и все равно не парсит массив в строку, поэтому координаты пока отдельно
      // const qs = queryString.stringify(params, { arrayFormat: 'comma' });
      var qs = queryString.stringify(params);

      if (location_with_radius_string) {
        return this.api.get("search/feed/?".concat(qs, "&location_with_radius=").concat(location_with_radius_string));
      } else {
        return this.api.get("search/feed/?".concat(qs));
      }
    }
  }, {
    key: "searchLikes",
    value: function searchLikes(params) {
      var qs = queryString.stringify(params);
      return this.api.get("search_likes/feed/?".concat(qs));
    }
  }, {
    key: "getTotalLikesCount",
    value: function getTotalLikesCount() {
      return this.api.get('search_likes/feed/counter/');
    }
  }, {
    key: "getFeedUpdates",
    value: function getFeedUpdates(params, location_with_radius_string) {
      var qs = queryString.stringify(_objectSpread({}, params, {
        start_at: Math.trunc(Date.now() / 1000)
      }));

      if (location_with_radius_string) {
        return this.api.get("search/feed/check_new/?".concat(qs, "&location_with_radius=").concat(location_with_radius_string));
      } else {
        return this.api.get("search/feed/check_new/?".concat(qs));
      }
    }
  }, {
    key: "getCities",
    value: function getCities(query, locale) {
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
      return this.api.get("cities/cities/?lang=".concat(locale, "&q=").concat(encodeURI(query), "&page_size=").concat(pageSize));
    }
  }, {
    key: "getTopCities",
    value: function getTopCities(locale) {
      return this.api.get("geo/popular_cities/?lang=".concat(locale));
    }
  }, {
    key: "getCity",
    value: function getCity(cityId) {
      return this.api.get("cities/cities/".concat(cityId, "/"));
    }
  }, {
    key: "getLikedCities",
    value: function getLikedCities() {
      return this.api.get('search_likes/cities/');
    }
  }, {
    key: "getBlockedUsersCities",
    value: function getBlockedUsersCities() {
      return this.api.get('search_blocks/cities/');
    }
  }, {
    key: "getAnonymousUser",
    value: function getAnonymousUser(userId) {
      // Hack for custom authorization
      return Request.get("".concat(this.api.apiEndpoint, "anonymous_users/api/users/").concat(userId)).set('Authorization', md5("".concat(this.anonymousUserServiceKey).concat(userId)));
    }
    /**
     * get languages list
     * Turn-ons language
     * @param {string} lang
     */

  }, {
    key: "getSpokenLanguages",
    value: function getSpokenLanguages(lang) {
      return this.api.get('spoken-languages/', {
        apiKey: this.apiKey,
        lang: lang
      });
    }
  }, {
    key: "getLikedSpokenLanguages",
    value: function getLikedSpokenLanguages() {
      return this.api.get('search_likes/spoken-languages/', {
        apiKey: this.apiKey
      });
    }
  }, {
    key: "getBlockedUsersSpokenLanguages",
    value: function getBlockedUsersSpokenLanguages() {
      return this.api.get('search_blocks/spoken-languages/', {
        apiKey: this.apiKey
      });
    }
    /**
    * Check for smart feed
    * @return {Promise}
    * @soulsdk soul.users.getShowSmartFeed
    * @example soul.users.getShowSmartFeed()
    */

  }, {
    key: "getShowSmartFeed",
    value: function getShowSmartFeed() {
      return this.api.get('search/get-show-smart-feed/');
    }
    /**
    * Calculate user category
    * @return {Promise}
    * @soulsdk soul.users.calculateUserCategory
    * @example soul.users.calculateUserCategory()
    */

  }, {
    key: "calculateUserCategory",
    value: function calculateUserCategory() {
      return this.api.post('v2_users/category/calculate/');
    }
  }]);

  return Users;
}(SoulModule);

module.exports = Users;